import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_gen_2_auto_recovery from '@devices/settings/device_settings/safety_gen_2_auto_recovery.js';
import plugs_app_settings from '@devices/settings/device_settings/plugs_app_settings.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2_plug_pm from '@devices/settings/device_settings/settings_gen_2_plug_pm';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPlugPMG3',
	friendly_name: 'Plug PM G3',
	family: 'power_meter',
	isPM: true,
	modes: {
		power_meter: {
			//ToDo: this is not correct, should be something else as category
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			meters: 1,
			rollers: 0,
			control_holder: 0,
			default_icon: 'socket.png',
			settings: [
				// timer_gen_2,//not supported
				// schedule_gen_2,//currently not supported
				webhooks_gen_2,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_gen_2,
				// safety_gen_2_auto_recovery,//currently not supported
				plugs_app_settings,
				share,
				settings_gen_2_plug_pm,
			],
		},
	},
};
